export const BenefitTypes = {
  DATA: 'data',
  DISCOUNT: 'discount',
  FULLSPEEDDATA: 'fullSpeedData',
  PROMOTION: 'promo1Benefit',
  ACCESSORY: 'applicableAccessoryBenefit'
};
